import React from 'react'

const scrolltotop = () => {
  return <div></div>
}

export default scrolltotop
